import { DEFAULT_API_CONFIG } from './apiConfig';

export const fetchProperty = async id => {
  const url = `${DEFAULT_API_CONFIG.url}/ExternalServices/getBetterView/${id}`;
  const token = localStorage.getItem('token');
  let headers = {};
  if (token) {
    headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
  }
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers,
    });
    const json = await response.json();
    return json;
  } catch (e) {
    throw e;
  }
};


export const fetchBetterViewData = async id => {
  const url = `${DEFAULT_API_CONFIG.url}/ExternalServices/getBetterViewV2/${id}`;
  const token = localStorage.getItem('token');
  let headers = {};
  if (token) {
    headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
  }
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers,
    });
    if(response.status === 204) {
      return null;
    }
    const json = await response.json();
    return json;
  } catch (e) {
    throw e;
  }
};

export const createOrdersInSalesforce = async () => {
  const url = `${DEFAULT_API_CONFIG.url}/ExternalServices/PushOrdersToSalesforce`;
  const token = localStorage.getItem('token');
  let headers = {};
  if (token) {
    headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
  }
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers,
    });
    return response.ok ? await response.json() : Promise.reject(response);
  } catch (e) {
    throw e;
  }
};

export const UpdateClosedOrdersToSalesforce = async (startDate, endDate, orderTicket) => {
  const url = `${DEFAULT_API_CONFIG.url}/ExternalServices/UpdateClosedOrdersToSalesforce?_startDate=${
    !!startDate ? startDate.toJSON() : ''
  }
        &_endDate=${!!endDate ? endDate.toJSON() : ''}&_orderTicket=${!!orderTicket ? orderTicket : ''}`;
  const token = localStorage.getItem('token');
  let headers = {};
  if (token) {
    headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
  }
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers,
    });
    return response.ok ? await response.json() : Promise.reject(response);
  } catch (e) {
    throw e;
  }
};

export const ResyncHoverOrder = async (orderLineId) => {
  const url = `${DEFAULT_API_CONFIG.url}/ExternalServices/ResyncHoverOrder?orderlineId=${orderLineId}`;
  const token = localStorage.getItem('token');
  let headers = {};
  if (token) {
    headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
  }
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers,
    });
    return response.ok ? await response.json() : Promise.reject(response);
  } catch (e) {
    throw e;
  }
};

export const RetrieveHoverPhotos = async (orderLineId, hoverJobId) => {
  const url = `${DEFAULT_API_CONFIG.url}/ExternalServices/AddHoverPhotos?orderlineId=${orderLineId}&jobId=${hoverJobId}`;
  const token = localStorage.getItem('token');
  let headers = {};
  if (token) {
    headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
  }
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers,
    });
    return response.ok ? await response.json() : Promise.reject(response);
  } catch (e) {
    throw e;
  }
};

export const DeleteHoverSketch = async (formImageId, orderlineId) => {
  const url = `${DEFAULT_API_CONFIG.url}/ExternalServices/DeleteHoverSketch?formImageId=${formImageId || 0}&orderlineId=${orderlineId}`;
  const token = localStorage.getItem('token');
  let headers = {};
  if (token) {
    headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
  }
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers,
    });
    return response.ok ? await response.json() : Promise.reject(response);
  } catch (e) {
    throw e;
  }
};

export const UploadHoverSketch = async (orderLineId) => {
  const url = `${DEFAULT_API_CONFIG.url}/ExternalServices/UploadHoverSketch?orderlineId=${orderLineId}`;
  const token = localStorage.getItem('token');
  let headers = {};
  if (token) {
    headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
  }
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers,
    });
    return response.ok ? await response.json() : Promise.reject(response);
  } catch (e) {
    throw e;
  }
};

export const SendFinalReportsToSalesforce = async (startDate, endDate, orderTicket) => {
  const url = `${DEFAULT_API_CONFIG.url}/ExternalServices/SendFinalReportsToSalesforce?_startDate=${
    !!startDate ? startDate.toJSON() : ''
  }
        &_endDate=${!!endDate ? endDate.toJSON() : ''}&_orderTicket=${!!orderTicket ? orderTicket : ''}`;
  const token = localStorage.getItem('token');
  let headers = {};
  if (token) {
    headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
  }
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers,
    });
    return response.ok ? await response.json() : Promise.reject(response);
  } catch (e) {
    throw e;
  }
};

export const removeVexcelData = async orderLineId => {
  const url = `${DEFAULT_API_CONFIG.url}/orders/removeVexcelData/${orderLineId}`;
  const token = localStorage.getItem('token');
  let headers = token
    ? { Accept: 'application/json', 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
    : {};
  const response = await fetch(url, {
    method: 'DELETE',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const addVexcelData = async orderLineId => {
  const url = `${DEFAULT_API_CONFIG.url}/orders/addVexcelData/${orderLineId}`;
  const token = localStorage.getItem('token');
  let headers = token
    ? { Accept: 'application/json', 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
    : {};
  const response = await fetch(url, {
    method: 'POST',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const aiPhotoReview = async orderLineId => {
  const url = `${DEFAULT_API_CONFIG.url}/ExternalServices/aiAnalyzeOrderPhotos/${orderLineId}`;
  let token = localStorage.getItem('token');
  let headers = token
    ? { Accept: 'application/json', 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
    : {};
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(orderLineId),
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};


export const resendNotifications = async orderLineId => {
  const url = `${DEFAULT_API_CONFIG.url}/orders/${orderLineId}/resendnotifications`;
  let token = localStorage.getItem('token');
  let headers = token
    ? { Accept: 'application/json', 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
    : {};
  const response = await fetch(url, {
    method: 'POST',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};


export const processAdvanceToQA = async orderLineId => {
  const url = `${DEFAULT_API_CONFIG.url}/orders/${orderLineId}/advancetoqa`;
  let token = localStorage.getItem('token');
  let headers = token
    ? { Accept: 'application/json', 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
    : {};
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

